import { Box, Image, Text } from "@salestrak/ui";
import asset_black_logo from "#app/assets/images/black-logo.png";
import type { Omittable } from "@salestrak/ui";

type SalesTrakLogoProps = Omittable<{
  height?: number;
  showText?: boolean;
  size?: "default" | "hero";
}>;

// One black asset with `dark:invert` covers both themes. A JS branch on
// `useTheme()` would not work here anyway: it reports the stored mode, not
// the resolved one. The entity system's SalesTrak avatar uses the same idiom.
export function SalesTrakLogo({
  height,
  showText = true,
  size = "default",
}: SalesTrakLogoProps) {
  const isHero = size === "hero";
  const iconSize = height ?? (isHero ? 48 : 24);

  return (
    <Box direction="row" align="center" gap={isHero ? "md" : "sm"}>
      <Box width={iconSize} height={iconSize}>
        <Image
          src={asset_black_logo}
          alt="SalesTrak logo"
          fill
          fit="contain"
          className="dark:invert"
        />
      </Box>
      {showText && (
        <Text
          weight={isHero ? "bold" : "semibold"}
          size={isHero ? "2xl" : "lg"}
        >
          SalesTrak
        </Text>
      )}
    </Box>
  );
}

export function SalesTrakLoading({ height = 48 }: { height?: number }) {
  // Was an RN Animated opacity loop (0.4 → 1 → 0.4, 800ms legs). The library
  // Image `pulse` prop runs the pixel-identical CSS keyframe (1.6s cycle).
  return (
    <Box width={height} height={height}>
      <Image
        src={asset_black_logo}
        alt="Loading"
        fill
        fit="contain"
        pulse
        className="dark:invert"
      />
    </Box>
  );
}
